import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';

import { Alert, AlertType, AlertOptions } from "@app/modules/alert/alert.model";
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { AzureUser } from "@app/models/azure-user";
import { ApplicationInsightsLoggingService } from "@app/services/application-insights-logging.service";

@Injectable({ providedIn: "root" })
export class AlertService {
    constructor(
        private toastr: ToastrService,
        private applicationInsightsLoggingService: ApplicationInsightsLoggingService
    ){}
    private subject = new Subject<Alert>();
    private defaultId = "default-alert";
   
    // enable subscribing to alerts observable
    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject
            .asObservable()
            .pipe(filter((x) => x && x.id === id));
    }

    // convenience methods
    success(message: string, options?: AlertOptions) {
        this.alert(new Alert({ ...options, type: AlertType.Success, message }));
    }

    //Note: using this alert is probably better than toadter for screen printing by users to show errors.
    error(message: string, options?: AlertOptions, error?: Error) {
        let currentUser: AzureUser = getCurrentUserFromStorage();
        //this.toastr.error( message, "Error", { timeOut: 5000, closeButton: true });
       this.alert(new Alert({ ...options, type: AlertType.Error, message }));

       //if an Error was passed, use it, otherwise construct one.
       let except : Error = { name: 'Application Error', message : message}
        if (error) {
            except = error;
        }
       this.applicationInsightsLoggingService.logException(except,1);
       this.applicationInsightsLoggingService.logTrace(message + " - [" + currentUser.displayName + "]");

       
    }

    info(message: string, options?: AlertOptions) {
        this.alert(new Alert({ ...options, type: AlertType.Info, message }));
    }

    warn(message: string, options?: AlertOptions) {
        this.alert(new Alert({ ...options, type: AlertType.Warning, message }));
    }

    // main alert method
    alert(alert: Alert) {
        alert.id = alert.id || this.defaultId;
        this.subject.next(alert);
    }

    // clear alerts
    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id }));
    }
}
